<template>
  <div class="rewardWar">
    <!-- 保持原有模板结构不变 -->
    <div class="dvDecoration2">
      <div class="dvDecoraBox">
        <dv-decoration-2 class="dvD2" style="width: 200px; height: 10px" />
        <dv-decoration-2 style="width: 200px; height: 10px" />
      </div>
    </div>
    <div class="rewardBox">
      <div class="rewardTitle">奖励公示</div>
      <div class="rewardTable">
        <dv-scroll-board :config="rewardData" style="width: 100%; height: 110px" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 原始数据（包含数值型amount）
      originalData: [
        { date: '2024.11.21', name: '郭胜华', content: '线边车间硝饼超量', amount: 120 },
        { date: '2024.12.28', name: '刘华淮', content: '线边车间垃圾未分类', amount: 120 },
        { date: '2024.12.30', name: '王外华', content: '工房未按划线管理', amount: 120 },
        { date: '2025.01.03', name: '宋时英', content: '关门作业', amount: 120 },
        { date: '2025.01.05', name: '吴升良', content: '部分员工跨域门禁', amount: 120 },
        { date: '2025.01.06', name: '陈芳蓉', content: '运关成品入库超高', amount: 180 },
        { date: '2025.01.07', name: '汤美平', content: '30号结鞭车间道堵塞', amount: 180 },
        { date: '2025.01.08', name: '刘年秀', content: '24号硝饼中转动态超员', amount: 180 },
        { date: '2025.01.15', name: '林小玲', content: '电瓶车在生产区超速行驶', amount: -200 }
      ],
      rewardData: {
        header: ['日期', '姓名', '隐患报告或建议内容', '奖罚金额'],
        data: [], // 通过processedData生成
        columnWidth: [100, 65, 250, 100],
        waitTime: 1000,
        headerHeight: 20,
        headerBGC: 'rgba(255,255,255,0.2)',
        oddRowBGC: 'rgba(255, 255, 255, 0.1)',
        evenRowBGC: 'rgba(0, 0, 0,0.1)',
        rowNum: 3,
        align: ['center', 'center', 'center', 'center']
      }
    }
  },
  created() {
    this.processData()
  },
  methods: {
    // 数据处理方法
    processData() {
      this.rewardData.data = this.originalData.map(item => {
        const color = item.amount >= 0 ? '#ffffff' : '#ff4d4d'
        return [
          item.date,
          this.formatName(item.name),
          item.content,
          `<span style="color: ${color}">${item.amount}元</span>`
        ]
      })
    },
    // 姓名格式化
    formatName(name) {
      return name.charAt(0) + '**'
    }
  }
}
</script>

<style lang="less" scoped>
/* 原有样式保持不变 */
.rewardWar {
  width: 100%;
  height: 26%;
  box-sizing: border-box;

  .dvDecoration2 {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;

    .dvDecoraBox {
      display: flex;
      flex-direction: row;
      align-items: center;

      .dvD2 {
        margin-bottom: -1px;
        transform: rotate(180deg);
      }
    }
  }

  .rewardBox {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;

    .rewardTitle {
      width: 20px;
      font-weight: 700;
      font-size: 17px;
      margin-right: -2%;
    }

    .rewardTable {
      width: 90%;
    }
  }
}
</style>
